import { render } from "./SideNavbar.vue?vue&type=template&id=067209be&scoped=true"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"

import "./SideNavbar.vue?vue&type=style&index=0&id=067209be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067209be"]])

export default __exports__